<template>
  <router-view />
  <Toaster />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import Toaster from '@/components/Toaster.vue'
import { usePermissionsStore } from '@/stores/permissions'

onMounted(() => {
  const permissionsStore = usePermissionsStore()
  permissionsStore.hydrate()
})
</script>

<style>
#app {
  width: 100%;
  min-height: 100vh;
}
</style>